import { useQueryOrgPrimaryCluster, useUpdateOrgPrimaryCluster } from '@ion/api';
import { useUserContext } from '@ion/user';

import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';

export default function usePrimaryClusterIndicatorConfig({ clusterId }) {
  const { primaryClusterId, loading } = useQueryOrgPrimaryCluster();
  const [updatePrimaryCluster] = useUpdateOrgPrimaryCluster();
  const { currentOrg } = useUserContext();
  const { secretStorageDevelopmentEnabled } = useFeatureEnabled(FEATURE_FLAGS.secretStorageDevelopment);

  const isPrimary = clusterId === primaryClusterId;
  const onSetAsPrimary = () => {
    updatePrimaryCluster({ orgId: currentOrg.id, primaryClusterId: clusterId });
  };
  const chipProps = buildChipProps({ isPrimary, onSetAsPrimary, clusterId });

  return {
    shouldShow: secretStorageDevelopmentEnabled,
    visibility: loading && 'hidden',
    chipProps,
  };
}

function buildChipProps({ isPrimary, onSetAsPrimary, clusterId }) {
  if (isPrimary) {
    return {
      label: 'Primary',
      color: 'primary',
      variant: 'filled',
      'data-test-id': 'primary-cluster-badge',
    };
  }

  return {
    label: 'Set as Primary',
    color: 'primary',
    variant: 'outlined',
    clickable: true,
    onClick: onSetAsPrimary,
    'data-test-id': `set-primary-cluster-button-${clusterId}`,
  };
}
